import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';

import '../layout3/style/pt-menu.less';
import Menu, {SubMenu, Item as MenuItem} from '../../../../../../pc4public/portal/_rc/_rc-menu-7.0.3/src';

let isScrolling = false;

@inject("portalThemeStore")
@observer
class E9NavMenu extends React.Component {
    constructor(props) {
        super(props);
        this.getNavMenu = this.getNavMenu.bind(this);
        this.onNext = this.onNext.bind(this);
        this.onPrev = this.onPrev.bind(this);
        this.onTitleClick = this.onTitleClick.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    componentDidMount() {
        const $menu = $('.e9navbar-container .pt-menu-root');
        const containerWidth = $(window).width() - 72;
        const contentWidth = $menu.width();

        if (contentWidth > containerWidth) {
            this.refs['prev'].style.display = 'block';
            this.refs['next'].style.display = 'block';
        }
    }

    render() {
        const {portalThemeStore} = this.props;
        const {themeInfo, frontEndMenu = [], leftMenuObj} = portalThemeStore;
        const {themeData = {}} = themeInfo;
        const {styleConfig = {}} = themeData;
        const {leftmenu = {}} = styleConfig;
        const fontSize = parseInt(leftmenu.titleFontSize || '12px');
        const {leftMenuSelected = {}} = leftMenuObj;
        const _frontEndMenu = toJS(frontEndMenu);
        const _leftMenuSelected = toJS(leftMenuSelected);
        const _selectedKeys = [_leftMenuSelected.id || ''];

        return (
            <div className={`e9navbar-container wea-f${fontSize}`}>
                <span ref="prev" className="e9navbar-prev" onClick={this.onPrev}><span className="ant-tabs-tab-prev-icon"/></span>
                <Menu
                    mode="horizontal"
                    prefixCls="pt-menu"
                    openAnimation="zoom"
                    subMenuCloseDelay={0.2}
                    selectedKeys={_selectedKeys}
                    onClick={this.onSelect}
                >
                    {this.getNavMenu(_frontEndMenu, 1, fontSize)}
                </Menu>
                <span ref="next" className="e9navbar-next" onClick={this.onNext}><span className="ant-tabs-tab-next-icon"/></span>
            </div>
        );
    }

    getNavMenu(data, level, fontSize) {
        return data.map((item) => {
            if (item.child && item.child.length) {
                return (
                    <SubMenu
                        key={item.id}
                        popupClassName={`e9navbar-sub-container wea-f${fontSize}`}
                        title={
                            level == 1 ? (
                                    <span className="e9navbar-top-menu-icon">
                                        {item.icon ? <i className={item.icon}/> : <i className={`wevicon-top-menu-default wevicon-top-menu-${item.infoId || 0}`}/>}
                                        <span title={item.name}>{item.name}</span>
                                    </span>
                                ) : (
                                    <span title={item.name}>{item.name}</span>
                                )
                        }
                        data={item}
                        onTitleClick={() => this.onTitleClick(item)}
                    >
                        {this.getNavMenu(item.child, level + 1, fontSize)}
                    </SubMenu>
                );
            } else {
                return (
                    <MenuItem key={item.id} data={item}>
                        {
                            level == 1 ? (
                                    <div className="pt-menu-item-title">
                                        <span className="e9navbar-top-menu-icon">
                                            {item.icon ? <i className={item.icon}/> : <i className={`wevicon-top-menu-default wevicon-top-menu-${item.infoId || 0}`}/>}
                                            <span title={item.name}>{item.name}</span>
                                        </span>
                                    </div>
                                ) : (
                                    <span title={item.name}>{item.name}</span>
                                )
                        }
                    </MenuItem>
                );
            }
        });
    }

    onNext() {
        const $menu = $('.e9navbar-container .pt-menu-root');
        const containerWidth = $(window).width() - 72;
        const contentWidth = $menu.width();
        const contentLeft = $menu.position().left;
        if (!isScrolling && (contentWidth + contentLeft > containerWidth)) {
            isScrolling = true;
            $menu.animate({left: contentLeft - containerWidth / 2}, 300, function () {
                isScrolling = false;
            });
        }
    }

    onPrev() {
        const $menu = $('.e9navbar-container .pt-menu-root');
        const containerWidth = $(window).width() - 72;
        const contentWidth = $menu.width();
        const contentLeft = $menu.position().left;
        if (!isScrolling && contentLeft < 0) {
            isScrolling = true;
            $menu.animate({left: contentLeft + containerWidth / 2}, 300, function () {
                isScrolling = false;
            });
        }
    }

    onTitleClick(data) {
        const {portalThemeStore} = this.props;

        if (data.mobxrouteurl || data.fullrouteurl || (data.url && data.url != 'javascript:void(0);')) {
            portalThemeStore.onLeftMenuSelectedChange(data);
            portalThemeStore.onLoadMain(data);
        } else if (data.child && data.child.length) {
            let item = data.child[0];

            if(item.url != ''){
                if(item.url== '/spa/document/static/index.html#/main/document/add'
                    || item.url== '/spa/document/static/index.html#/main/document/search'
                    || item.url== '/spa/workflow/index_mobx.jsp#/main/workflow/add'
                    || item.url== '/spa/workflow/index_mobx.jsp#/main/workflow/queryFlowResult'
                    || item.url== '/spa/workflow/index_mobx.jsp#/main/workflow/supervise'){
                    item.url = item.url + "?menuidforportal=" + "left_" + item.infoId;
                }

                if(item.url && item.url.indexOf('#') != '-1'){
                    let urlArr = item.url.split('#');
                    if(urlArr[1] && urlArr[1].indexOf('?')!= '-1'){
                        item.url = item.url + "&tabTitle=" + item.name;
                    }else {
                        item.url = item.url + "?tabTitle=" + item.name;
                    }
                }else if(item.url && item.url.indexOf('?') != '-1'){
                    item.url = item.url + "&tabTitle=" + item.name;
                }else {
                    item.url = item.url + "?tabTitle=" + item.name;
                }
            }

            for (; ;) {
                if (item.mobxrouteurl || item.fullrouteurl || (item.url && item.url != 'javascript:void(0);')) {
                    portalThemeStore.onLeftMenuSelectedChange(item);
                    portalThemeStore.onLoadMain(item);
                    break;
                } else if (item.child && item.child.length) {
                    item = item.child[0];
                } else {
                    break;
                }
            }
        }
    }

    onSelect(e) {
        const {data} = e.item.props;
        const {portalThemeStore} = this.props;

        if(data.url != ''){
            if(data.url== '/spa/document/static/index.html#/main/document/add'
                || data.url== '/spa/document/static/index.html#/main/document/search'
                || data.url== '/spa/workflow/index_mobx.jsp#/main/workflow/add'
                || data.url== '/spa/workflow/index_mobx.jsp#/main/workflow/queryFlowResult'
                || data.url== '/spa/workflow/index_mobx.jsp#/main/workflow/supervise'){
                data.url = data.url + "?menuidforportal=" + "left_" + data.infoId;
            }
        }

        if(data.url && data.url.indexOf('#') != '-1'){
            let urlArr = data.url.split('#');
            if(urlArr[1] && urlArr[1].indexOf('?')!= '-1'){
                data.url = data.url + "&tabTitle=" + data.name;
            }else {
                data.url = data.url + "?tabTitle=" + data.name;
            }
        }else if(data.url && data.url.indexOf('?') != '-1'){
            data.url = data.url + "&tabTitle=" + data.name;
        }else {
            data.url = data.url + "?tabTitle=" + data.name;
        }

        portalThemeStore.onLeftMenuSelectedChange(data);
        portalThemeStore.onLoadMain(data);
    }
}

export default E9NavMenu;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/layout2/E9NavMenu.js